import React from 'react'
// import config from '../../config'
import format from '../../helpers/format'
// import { Link, LinkIcon } from '../'

const EsgConfig = {
  esgNamesLabels: [
    {
      label: 'Military weapon weight',
      value: 'wff_mil_weight',
    },
    {
      label: 'Military contractors',
      value: 'mmc_weight',
    },
    {
      label: 'Nuclear weapons',
      value: 'nw_weight',
    },
    {
      label: 'Controversial weapons',
      value: 'cm_weight',
    }
  ],
  esgOptions: {
    wff_mil_weight: {
      id: 'wff_mil_weight',
      icon: 'icons_step4',
      fieldLabel: 'wff_mil_weight',
      benchLabel: 'wff_mil_weight',
      valueLabel: 'Military weapon weight',
      direction: 'ascending',
      page: 'military-weapon-investments',
      label: 'in military weapons',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in military weapon companies
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in military weapon companies
          </span>
        )
      }
    },
    mmc_weight: {
      id: 'mmc_weight',
      icon: 'icons_step4',
      fieldLabel: 'mmc_weight',
      benchLabel: 'mmc_weight',
      valueLabel: 'Major military contractors weight',
      direction: 'ascending',
      page: 'major-military-contractor-investments',
      label: 'in major military contractors',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in major military contractors
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in major military contractors
          </span>
        )
      }
    },
    nw_weight: {
      id: 'nw_weight',
      icon: 'icons_step4',
      fieldLabel: 'nw_weight',
      benchLabel: 'nw_weight',
      valueLabel: 'Nuclear weapons weight',
      direction: 'ascending',
      page: 'nuclear-weapons-investments',
      label: 'in manufacturers/servicers of nuclear weapons',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in manufacturers/servicers of nuclear weapons
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in manufacturers/servicers of nuclear weapons
          </span>
        )
      }
    },
    cm_weight: {
      id: 'cm_weight',
      icon: 'icons_step4',
      fieldLabel: 'cm_weight',
      benchLabel: 'cm_weight',
      valueLabel: 'Controversial weapons weight',
      direction: 'ascending',
      page: 'cluster-munitions-investments',
      label: 'in manufacturers of controversial weapons',
      units: null,
      unitsExpanded: null,
      diffGood: (diff) => (diff < 0),
      diffStyle: (diff) => (diff > 0) ? 'higher-bad' : 'lower-good',
      moreLess: (diff) => (diff > 0) ? 'More invested' : 'Less invested',
      format : (val) => format.perc(val),
      formatExpanded: (val, moreLess, postiveNegative, url) => {
        if (val === 0) {
          return (
            <span>
              <strong>the same amount</strong> invested in manufacturers of controversial weapons
            </span>
          )
        }
        return (
          <span>
            <strong styleName={postiveNegative}>{format.perc(val)} {moreLess}</strong> invested in manufacturers of controversial weapons
          </span>
        )
      }
    },
  }
}

export default EsgConfig